@if (loading()) {
    <div class="pie-chart-wrapper" [class.small]="variant() === 'small'">
        <div class="pie-chart-container skeleton">
            <div class="skeleton-donut"></div>
        </div>
        @if (variant() === 'large') {
            <div class="legend-container skeleton">
                <div class="legend-header">
                    <span class="legend-label-col skeleton-text header-skeleton"></span>
                    <span class="legend-value-col skeleton-text header-skeleton"></span>
                </div>
                @for (row of [1, 2, 3, 4, 5]; track row) {
                    <div class="legend-row">
                        <span class="legend-label-col">
                            <span class="legend-color-dot skeleton-dot"></span>
                            <span class="skeleton-text label-skeleton"></span>
                        </span>
                        <span class="legend-value-col skeleton-text value-skeleton"></span>
                    </div>
                }
            </div>
        }
    </div>
} @else {
    <div class="pie-chart-wrapper" [class.small]="variant() === pieChartVariantEnum.SMALL">
        <div class="pie-chart-container">
            <div
                class="chart"
                echarts
                [options]="chartOptions()"
                (chartMouseOver)="onChartMouseOver($event)"
                (chartMouseOut)="onChartMouseOut()"
            ></div>
            <ng-content select="[chartFooter]"></ng-content>
        </div>
        @if (variant() === pieChartVariantEnum.LARGE) {
            <div class="legend-container">
                <div class="legend-header">
                    <span class="legend-label-col">{{ labelColumnHeader() }}</span>
                    <span class="legend-value-col">{{ valueColumnHeader() }}</span>
                </div>
                @for (segment of computedSegments(); track segment.label; let index = $index) {
                    <div class="legend-row" [class.highlighted]="highlightedIndex() === index">
                        <span class="legend-label-col">
                            <span class="legend-color-dot" [style.background-color]="segment.color"></span>
                            <span class="legend-label">{{ segment.label }}</span>
                        </span>
                        <span class="legend-value-col">{{ segment.value }}</span>
                    </div>
                }
                <div class="legend-row total-row">
                    <span class="legend-label-col"></span>
                    <span class="legend-value-col">{{ totalValue() }}</span>
                </div>
            </div>
        }
    </div>
}
